import "core-js/modules/es.number.constructor.js";
import styled from 'styled-components';
import { getFont, getLineHeight } from '@finect/tabular-utils/getFont';
export var Badge = styled.span.withConfig({
  displayName: "partials__Badge",
  componentId: "sc-11353an-0"
})(["display:inline-flex;overflow:hidden;height:", ";border-radius:4px;box-shadow:0 1px 3px 0 rgb(46 46 51 / 0.25);background-color:", ";color:", ";cursor:default;&:not(:first-of-type){margin-left:6px;}svg{min-width:22px;}"], "".concat(1.2 * Number(getLineHeight(0, 'xcompact')), "rem"), function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  return type === 'certificate' ? theme.colors.uiD : theme.colors.accent3;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciaryLL;
});
export var BadgeTitle = styled.span.withConfig({
  displayName: "partials__BadgeTitle",
  componentId: "sc-11353an-1"
})(["", " padding:0 8px;font-weight:500;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;overflow-wrap:break-word;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:", ";line-height:", ";"], getFont('0', 'xcompact'), function (_ref3) {
  var _ref3$lines = _ref3.lines,
    lines = _ref3$lines === void 0 ? 1 : _ref3$lines;
  return lines;
}, getLineHeight(1, 'xcompact'));
export var BadgeContentImage = styled.div.withConfig({
  displayName: "partials__BadgeContentImage",
  componentId: "sc-11353an-2"
})(["background-color:#fff;"]);
export var BadgeImage = styled.img.withConfig({
  displayName: "partials__BadgeImage",
  componentId: "sc-11353an-3"
})(["height:", ";"], "".concat(1.2 * Number(getLineHeight(0, 'xcompact')), "rem"));